import _ from 'lodash';
import themeStrings from './strings.json';
import baseTheme from '../base';
import logoUri from './images/logo.svg';
import faviconUri from './images/favicon.png';
import leftChevron from './icons/leftChevron.svg';
import rightChevron from './icons/rightChevron.svg';
import link from './icons/link.svg';
import close from './icons/close.svg';
// import tick from './icons/tick.svg';

const palette = {
  red: '#eb1701',
  black: '#222526',
  grey: '#d2d6d7',
  dark: '#A5171C',
  lightGrey: '#e6eaeb',
  darkGrey: '#6e7070',
  green: '#00C725'
};

const colours = {
  primary: palette.red,
  accent: palette.red,
  link: palette.black,
  bg: 'white',
  black: palette.black,
  muted: palette.darkGrey,
  border: palette.grey,
  hover: palette.lightGrey,
  positive: palette.green,
  alert: palette.black,
  dark: palette.dark,
  toggleTrack: palette.green,
  banner: {
    background: palette.black,
    primary: 'white',
    secondary: '#adadad'
  }
};

const borders = {
  radius: 0
};

const assets = {
  brand: logoUri,
  favicon: faviconUri
};

const icons = {
  leftChevron,
  rightChevron,
  link,
  close
  // tick
};

const whitespace = {
  xs: '5px',
  small: '15px',
  base: '20px',
  large: '30px',
  xl: '40px',
  addon: '5px',
  gutter: 0
};

const type = {
  base: {
    fontFamily: 'TheSun',
    fontSize: '16px',
    color: colours.black,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left'
  },
  h1: {
    fontFamily: 'TheSunCondensed',
    fontSize: '32px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: colours.primary,
    margin: `${whitespace.small} 0`,
    padding: 0
  },
  h2: {
    fontFamily: 'TheSun',
    fontSize: '24px',
    fontWeight: '700',
    color: colours.primary,
    margin: 0,
    padding: 0,
    lineHeight: '1em',
    textAlign: 'center'
  },
  modal:{

  },
  modalh2: {
    fontFamily: 'TheSun',
    fontSize: '24px',
    fontWeight: '700',
    color: colours.primary,
    margin: 0,
    marginTop: whitespace.small
  },
  h3: {
    fontFamily: 'TheSun',
    fontSize: '18px',
    fontWeight: 700,
    color: colours.black
  },
  lead: {
    margin: 0,
    marginBottom: whitespace.base
  },
  small: {
    fontSize: '12px',
    color: colours.muted
  },
  link: {
    fontFamily: 'TheSun',
    color: colours.link,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  linkBlock: {
    textAlign: 'center',
    fontSize: '16px'
  },
  button: {
    fontSize: '14px'
  },
  notice: {
    textAlign: 'center',
    fontSize: '14px'
  }
};

const strings = _.merge(themeStrings, {
  product: {
    faq: {
      uri:
        'http://help.thesun.co.uk/site_sunarticledetail?categories=Communication_Preferences&id=000008886&retURL=site_sunhome&searchtext=&type=Member'
    }
  },
  analytics: {
    tag: 'thesun.marketingpreferencecentre'
  }
});

export default _.merge({}, baseTheme, {
  colours,
  assets,
  type,
  whitespace,
  icons,
  borders,
  strings
});
